import SEOHead from '@/components/SEOHead';
import RetoursHeroV2 from '@/components/marketing/retours/v2/RetoursHeroV2';
import RetoursProblemV2 from '@/components/marketing/retours/v2/RetoursProblemV2';
import RetoursHowItWorksV2 from '@/components/marketing/retours/v2/RetoursHowItWorksV2';
import RetoursPillarsV2 from '@/components/marketing/retours/v2/RetoursPillarsV2';
import { FinalCtaSection } from '@/components/marketing/v2/FinalCtaSection';

export default function GestionRetours() {
  return (
    <>
      <SEOHead
        title="Gestion des retours & remboursements POS | Velko"
        description="Gère les retours, échanges et remboursements de ta boutique : remboursement espèces, Mobile Money ou avoir client, échange avec différentiel, validation du gérant au-delà d'un seuil, anti-sur-remboursement et restock maîtrisé. Web, desktop, mobile — même hors ligne."
        path="/gestion-retours"
        ogImage="/brand/og/og-gestion-retours.png"
        breadcrumbs={[
          { name: 'Accueil', path: '/' },
          { name: 'Gestion des retours', path: '/gestion-retours' },
        ]}
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'SoftwareApplication',
          name: 'Velko — Gestion des retours',
          applicationCategory: 'BusinessApplication',
          operatingSystem: 'Web, Windows, macOS, Linux, Android',
          description:
            "Module de gestion des retours, échanges et remboursements pour point de vente : remboursement espèces / Mobile Money / avoir client, échange avec différentiel, seuil de validation gérant, anti-sur-remboursement, restock contrôlé.",
          offers: {
            '@type': 'Offer',
            priceCurrency: 'XOF',
            price: '0',
          },
        }}
      />

      <RetoursHeroV2 />
      <RetoursProblemV2 />
      <RetoursHowItWorksV2 />
      <RetoursPillarsV2 />
      <FinalCtaSection
        eyebrow="Reprends le contrôle"
        title="Des retours carrés."
        highlight="Une caisse toujours juste."
        subtitle="Retour, échange ou avoir — avec validation du gérant et anti-sur-remboursement. Le stock et la caisse restent exacts, automatiquement."
        primaryLabel="Commencer gratuitement"
        primaryTo="/register"
        secondaryLabel="Voir les tarifs"
        secondaryTo="/tarifs"
        guarantees={['Validation gérant', 'Espèces · MoMo · avoir', 'Hors ligne natif', 'Support FR']}
      />
    </>
  );
}
